module.exports = __webpack_public_path__ + "img/0Q3B7497_Wood_MockedUp.603c6913.jpg";